import NewPartnerPopover from "./NewPartnerPopover";
import { useRef, useState } from "react";
import { useAppDispatch } from "hooks/hooks";
import {
  getAllPartnersBySearchParams,
  selectState,
  setNewPartnerPopoverOpen,
  setSearchPopoverState,
} from "../main.slice";
import { useSelector } from "react-redux";
import SearchPartnersPopover from "./SearchPartnersPopover";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { useLocation, useNavigate } from "react-router-dom";
import Popover from "components/Popover/Popover";
import PrintPartners from "./PrintPartners";
import { useForm } from "react-hook-form";
import {
  ICreatePartnerRequestParams,
  IGetAllPartnersRequestParams
} from "Dashboard/scenes/Partners/domain";
import { IOption } from "Dashboard/domain/IOption";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { isEqual } from "lodash";
import { usePagePrint } from "hooks/usePagePrint";
import { INavigationStateBackTo } from "authentication/domain/INavigationState";

export const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { newPartnerPopoverOpen, searchPopover }
    = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = usePagePrint(componentRef);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    setFocus,
    reset,
  } = useForm<ICreatePartnerRequestParams>();

  const [activityValue, setActivityValue]
    = useState<IOption | undefined>(undefined);
  const [municipalityValue, setMunicipalityValue]
    = useState<IOption | undefined>(undefined);

  const [bankAccount, setBankAccount] = useState("");
  const [bankAccountError, setBankAccountError]
    = useState<string | undefined>("");

  const resetForm = () => {
    reset();
    setActivityValue(undefined);
    setMunicipalityValue(undefined);
    setBankAccount("");
    setBankAccountError("");
  };

  const searchDefaultValues: IGetAllPartnersRequestParams = {
    search: "",
    sortBy: "",
  };

  const {
    register: searchRegister,
    handleSubmit: searchHandleSubmit,
    reset: searchReset,
    getValues: searchGetValues,
    setFocus: searchSetFocus
  } = useForm<IGetAllPartnersRequestParams>({
    defaultValues: searchDefaultValues
  });

  const isSearchFormEmpty
    = isEqual(searchGetValues(), searchDefaultValues);

  const resetSearch = () => {
    dispatch(getAllPartnersBySearchParams(searchDefaultValues));
    searchReset(searchDefaultValues);
  };

  const state: INavigationStateBackTo | undefined = location.state;
  const backTo = state?.backTo;
  const handleBack = () => {
    if (backTo?.pathname) {
      navigate(`${backTo.pathname}${backTo.search ?? ""}`, {
        state: backTo.state,
        replace: true,
      });
    } else {
      navigate("/dashboard", { replace: true });
    }
  };

  return (
    <>
      <nav>
        <div className="toolbox">
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            tooltip="Glavni meni"
            toolbox={true}
            onClick={handleBack}
          />
        </div>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Add}
            tooltip="Novi"
            toolbox={true}
            onClick={hasWriteAccessTo(user, PARTNER_MODULE_NAME)
              ? () => dispatch(setNewPartnerPopoverOpen(true))
              : undefined}
          />
          <ToolboxButton
            icon={ToolboxButtonIcon.Search}
            tooltip="Traži"
            toolbox={true}
            onClick={() => dispatch(setSearchPopoverState({ isOpen: true }))}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => resetSearch()}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            tooltip="Štampa"
            toolbox={true}
            onClick={() => handlePrint()}
          />
        </div>
        <Popover
          isOpen={searchPopover.isOpen}
          onClose={() => {
            dispatch(setSearchPopoverState({ isOpen: false }));
          }}
          title="Pretraga"
          direction="right"
          arrowStyle={{ top: "42px" }}
          position={{ top: 10, left: 240 }}
        >
          <SearchPartnersPopover
            register={searchRegister}
            handleSubmit={searchHandleSubmit}
            setFocus={searchSetFocus}
          />
        </Popover>
        <Popover
          isOpen={newPartnerPopoverOpen}
          onClose={() => {
            dispatch(setNewPartnerPopoverOpen(false));
          }}
          title="Dodavanje novog saradnika"
          direction="right"
          arrowStyle={{ top: "42px" }}
          position={{ top: 10, left: 180 }}
        >
          <NewPartnerPopover
            handleSubmit={handleSubmit}
            control={control}
            register={register}
            setFocus={setFocus}
            errors={errors}
            activityValue={activityValue}
            setActivityValue={setActivityValue}
            municipalityValue={municipalityValue}
            setMunicipalityValue={setMunicipalityValue}
            bankAccount={bankAccount}
            setBankAccount={setBankAccount}
            bankAccountError={bankAccountError}
            setBankAccountError={setBankAccountError}
            resetForm={resetForm}
          />
        </Popover>
      </nav>
      {/* {searchPartnersModalOpen && <SearchPartnersModal />} */}
      <div ref={componentRef} className="print-area">
        <PrintPartners />
      </div>
    </>
  );
};
